var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectEndsSoonIconsGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 204.103,
    height: 147.143,
    viewBox: "0 0 204.103 147.143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1240",
    "data-name": "Rectangle 1240",
    width: 53.598,
    height: 52.302,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8978",
    "data-name": "Group 8978",
    transform: "translate(-1004.867 -92.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8955",
    "data-name": "Group 8955",
    transform: "translate(5 -61.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8954",
    "data-name": "Group 8954"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1238",
    "data-name": "Rectangle 1238",
    width: 94.93,
    height: 83.702,
    rx: 10.144,
    transform: "translate(1115.953 154.381) rotate(22)",
    fill: "#F09A0A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3",
    transform: "translate(1130.016 182.541) rotate(22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7337",
    "data-name": "Path 7337",
    d: "M36.722,11.91a3.694,3.694,0,0,0,1.2-2.731V5.694A3.7,3.7,0,0,0,34.232,2H13.524A3.7,3.7,0,0,0,9.83,5.694V9.179a3.694,3.694,0,0,0,1.2,2.731l7.6,6.97a2.9,2.9,0,0,1,0,4.233l-7.6,6.97a3.694,3.694,0,0,0-1.2,2.731V36.3a3.7,3.7,0,0,0,3.694,3.72H34.232a3.7,3.7,0,0,0,3.694-3.694V32.84a3.694,3.694,0,0,0-1.2-2.731l-7.6-6.97a2.9,2.9,0,0,1,0-4.233Zm-9.809,9.1a4.131,4.131,0,0,0,1.331,3.061l7.6,6.97a2.408,2.408,0,0,1,.792,1.793v3.485a2.433,2.433,0,0,1-2.408,2.433H13.524A2.433,2.433,0,0,1,11.1,36.325V32.84a2.408,2.408,0,0,1,.792-1.793l7.6-6.97a4.169,4.169,0,0,0,0-6.108L11.889,11A2.408,2.408,0,0,1,11.1,9.2V5.694a2.433,2.433,0,0,1,2.427-2.427H34.232a2.433,2.433,0,0,1,2.427,2.427V9.179a2.408,2.408,0,0,1-.792,1.793l-7.6,6.97A4.119,4.119,0,0,0,26.913,21.01Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7338",
    "data-name": "Path 7338",
    d: "M25.253,40.913,20.722,45.07A2.224,2.224,0,0,0,20,46.679v1.793a2.218,2.218,0,0,0,2.224,2.205H33a2.218,2.218,0,0,0,2.211-2.205V46.679a2.211,2.211,0,0,0-.722-1.609l-4.531-4.138A3.661,3.661,0,0,0,27.707,40,3.277,3.277,0,0,0,25.253,40.913Z",
    transform: "translate(-3.726 -13.921)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8953",
    "data-name": "Group 8953"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1237",
    "data-name": "Rectangle 1237",
    width: 109.628,
    height: 109.628,
    rx: 10.144,
    transform: "translate(999.867 191.896)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8964",
    "data-name": "Group 8964",
    transform: "translate(1031 158.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8963",
    "data-name": "Group 8963",
    transform: "translate(1.938 0.842)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7369",
    "data-name": "Path 7369",
    d: "M53.581,42.072V8.4a8.4,8.4,0,0,0-15.7-4.168H1.287A1.287,1.287,0,0,0,0,5.522c0,.015,0,.029,0,.044v45.45A1.287,1.287,0,0,0,1.287,52.3h45.45a6.861,6.861,0,0,0,6.86-6.86v-3.43ZM45.168,2.564a5.84,5.84,0,0,1,5.84,5.84V40.511a9.124,9.124,0,0,0-11.671,0V8.4a5.84,5.84,0,0,1,5.831-5.84M46.746,49.73H2.574V6.852H36.919a8.811,8.811,0,0,0-.154,1.6V44.155a.828.828,0,0,0,0,.146.23.23,0,0,0,0,.069,1.448,1.448,0,0,0,.043.18V44.6a1.06,1.06,0,0,0,.077.172v.06a.718.718,0,0,0,.2.18l.051.06a.778.778,0,0,0,.12.111l.06.051.154.094h.051l.163.06h.926l.189-.12a.142.142,0,0,1,.06,0,1.231,1.231,0,0,0,.129-.12h.051L39.148,45v-.06a.939.939,0,0,0,.069-.12,6.586,6.586,0,0,1,11.791-.214v.943a4.287,4.287,0,0,1-4.262,4.176",
    transform: "translate(0 0)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7370",
    "data-name": "Path 7370",
    d: "M12.145,41.24a5.634,5.634,0,1,0,5.634,5.634,5.634,5.634,0,0,0-5.634-5.634m0,8.7a3.061,3.061,0,1,1,3.061-3.061,3.061,3.061,0,0,1-3.061,3.061",
    transform: "translate(-0.927 -5.874)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7371",
    "data-name": "Path 7371",
    d: "M12.145,12.9a5.634,5.634,0,1,0,5.634,5.651A5.634,5.634,0,0,0,12.145,12.9Zm0,8.687a3.061,3.061,0,1,1,3.061-3.061v.026a3.061,3.061,0,0,1-3.061,3.036",
    transform: "translate(-0.927 -1.838)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7372",
    "data-name": "Path 7372",
    d: "M35.554,17.87H22.691v2.573h11.62v21.9H27.673l1.286-1.089a1.3,1.3,0,1,0-1.715-1.964l-3.936,3.362a1.278,1.278,0,0,0-.155,1.8,1.264,1.264,0,0,0,.155.155l3.936,3.362a1.306,1.306,0,0,0,.858.309,1.286,1.286,0,0,0,.858-2.273l-1.278-1.089h7.872a1.287,1.287,0,0,0,1.286-1.286V19.156a1.287,1.287,0,0,0-1.286-1.286",
    transform: "translate(-3.232 -2.546)",
    fill: "#040227"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectEndsSoonIconsGroup);
export default __webpack_public_path__ + "static/media/project-ends-soon-icons-group.40f672f39fec63ff8549811e2b26d036.svg";
export { ForwardRef as ReactComponent };